import { render, staticRenderFns } from "./TournamentHeader.vue?vue&type=template&id=0945c93c&scoped=true&"
import script from "./TournamentHeader.vue?vue&type=script&lang=js&"
export * from "./TournamentHeader.vue?vue&type=script&lang=js&"
import style0 from "./TournamentHeader.vue?vue&type=style&index=0&id=0945c93c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945c93c",
  null
  
)

component.options.__file = "TournamentHeader.vue"
export default component.exports